import React, { useEffect } from "react";
import { __ } from "@wordpress/i18n";
import { useStateValue } from "../../../../store/store";
import ColorPalettes from "../../../../components/color-palettes/color-palettes";
import sendPostMessage from "../../../../components/site-preview/utils";
import NextStepButton from "../../../../components/util/next-step-button/next-step-button";
import { Spacer } from "../../../../ui/style";

export const PALETTES = [
	{
		title: __("Default", "astra-sites"),
		colors: ["#1D53DD", "#0235B7", "#1A1C23", "#4B4F58", "#F6F7F8"],
	},
	{
		title: __("Style 1", "astra-sites"),
		colors: ["#EC0909", "#D30D0D", "#19150F", "#413E3A", "#F8F2F2"],
	},
	{
		title: __("Style 2", "astra-sites"),
		colors: ["#FD4973", "#F81B4F", "#19150F", "#483D40", "#F7F2F3"],
	},
	{
		title: __("Style 3", "astra-sites"),
		colors: ["#FF6333", "#FA430B", "#19150F", "#413E3A", "#F7F3ED"],
	},
	{
		title: __("Style 4", "astra-sites"),
		colors: ["#18DC44", "#1BC540", "#1A1C23", "#4B4F58", "#F2F7F3"],
	},
	{
		title: __("Style 5", "astra-sites"),
		colors: ["#FCEA43", "#F8E425", "#19150F", "#413E3A", "#959088"],
	},
];

const setColorPalettes = (palette) => {
	const data = new FormData();
	data.append("action", "astra_sites_set_site_data");
	data.append("param", "site-colors");
	data.append("palette", palette);
	data.append("security", starterTemplates.nonce);

	fetch(ajaxurl, {
		method: "post",
		body: data,
	});
};

const SiteColorsControls = (props) => {

	const [{ activePalate, templateResponse }, dispatch] = useStateValue();
	const { onNextClick, customizeStep } = props;

	if( templateResponse['astra-site-customizer-data'] ) {

		const globalPalette = templateResponse['astra-site-customizer-data']['astra-settings']['global-color-palette'];

		// Set palette value from astra settings in default palette.
		if( globalPalette ) {
			PALETTES[0]['colors'] = globalPalette.palette;
		}
	}

	const onPaletteChange = (palateIndex) => {
		dispatch({
			type: 'set',
			activePalate: palateIndex,
		});

		sendPostMessage({
			param: 'colorPalette',
			data: PALETTES[palateIndex],
		});
	};

	useEffect(() => {
		document.getElementById(
			'astra-starter-templates-preview'
		).onload = function () {
			sendPostMessage({
				param: 'colorPalette',
				data: PALETTES[activePalate],
			});
		};
	}, []);

	return (
		<>
			<ColorPalettes
				selected={activePalate}
				options={PALETTES}
				onChange={(palate, palateIndex) => {
					onPaletteChange(palateIndex);
				}}
			/>
			<Spacer />
			<NextStepButton
				customizeStep={customizeStep}
				after
				onClick={(event) => {
					onNextClick();
					setColorPalettes(JSON.stringify(PALETTES[activePalate]));
				}}
			>
				{__("Proceed", "astra-sites")}
			</NextStepButton>
		</>
	);
};

export default SiteColorsControls;
